import { useShowEpicPanel } from '@atlassian/jira-software-view-settings/src/controllers/index.tsx';
import { useBacklogSelector } from '../index.tsx';
import { getShowEpicAsPanel } from '../selectors/config/index.tsx';

export const useIsEpicPanelOpen = () => {
	const showEpicAsPanel = useBacklogSelector(getShowEpicAsPanel);
	const isEpicsOpen = useShowEpicPanel();

	if (!showEpicAsPanel) {
		return false;
	}
	return isEpicsOpen;
};
